import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b38cbac0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=b38cbac0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38cbac0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b38cbac0')) {
      api.createRecord('b38cbac0', component.options)
    } else {
      api.reload('b38cbac0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b38cbac0&scoped=true", function () {
      api.rerender('b38cbac0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/productInfo/index.vue"
export default component.exports